import { SortOrder } from "element-ui/types/table";

export class PresetSortConditionItem {
  sortType?: any;
  orderType: SortOrder;
}
